import { render, staticRenderFns } from "./OrderStatusChart.vue?vue&type=template&id=44544b93&scoped=true&"
import script from "./OrderStatusChart.vue?vue&type=script&lang=js&"
export * from "./OrderStatusChart.vue?vue&type=script&lang=js&"
import style0 from "./OrderStatusChart.vue?vue&type=style&index=0&id=44544b93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../DATA/projects/nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44544b93",
  null
  
)

export default component.exports